import React, { Component } from 'react'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import './proposal.scss'
import EventBus from '../common/EventBus.js'
import $ from "jquery"
import ProposalContent from "./content.component.jsx"
import Recorder from "../common/timespent/Recorder.jsx"
import { FormattedMessage } from "react-intl";
import Icon from "../common/icon/icon.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
const uuidv4 = require('uuid/v4')
const queryString = require('query-string')
import MetaTags from 'react-meta-tags'
import Pusher from 'pusher-js';

class Proposal extends Component {

    constructor(props, context) {
        super(props, context)

        const hash = this.props.match.params.hash
        const uri = queryString.parse(this.props.location.search)
        let mobile = new URLSearchParams(this.props.location.search).get("mobile")
        mobile = (mobile == 'true')

        this.state = {
            hash: hash,
            isDummy: hash === "dummy",
            documentId: uri.documentId,
            proposal: null,
            options: [],
            showApprovedMessage: false,
            visitId: uuidv4(),
            mobile,
            project: null,
        }
        this.updateTimeSpent = this.updateTimeSpent.bind(this)
        this.refreshProposal = this.refreshProposal.bind(this)
    }

    updateTimeSpent(data) {
        if (data.mainContent === this.mainContent && data.pricingTable === this.pricingTable) {
            return
        }
        this.mainContent = data.mainContent
        this.pricingTable = data.pricingTable
        AppContext.getApiClient().put('/proposals/' + this.state.hash + '/visits/' + this.state.visitId, {
            id: this.state.visitId,
            userAgent: navigator.userAgent,
            userId: AppContext.getUserLoggedIn() ? AppContext.getUserLoggedIn().id : '',
            duration: data.mainContent,
            durationOnPricingTable: data.pricingTable,
            fingerprintId: GlobalHelper.getFingerprintId(),
            accountId: this.state.proposal.quote.accountId,
            proposalId: this.state.proposal.id,
        }).then(res => {
            if (res.error) {
                this.rec.stop()
            }
        })
    }

    getProposal() {
        const qmProposalResponse = window.qmProposalResponse
        if (qmProposalResponse) {
            return Promise.resolve(qmProposalResponse)
        }
        return AppContext.getApiClient().get('/proposals/' + this.props.match.params.hash)
    }

    componentDidMount() {
        $('#mainContent').click()
        if (this.state.isDummy) {
            AppContext.getApiClient().get('/documents/' + this.state.documentId + '/dummy-proposals').then(res => {
                this.setState({
                    proposal: res.attributes.variables,
                })
            })
        } else {
            this.getProposal().then(res => {
                EventBus.dispatch(EventBus.TopicLocaleChange, {
                    locale: res.attributes.variables.global.language,
                })
                const prop = res.attributes.variables
                if (prop.quote.liveQuoteStatus === 'running') {
                    this.initLiveQuote(prop.global.pusherKey, prop.global.pusherCluster, prop.quote.id)
                }

                this.setState({
                    proposal: prop
                }, () => {
                    if (this.state.proposal.global.isDeleted || !['quote', 'invoice', 'price-list', 'scheduling-page'].includes(this.state.proposal.document.type)) {
                        return
                    }
                    this.rec = new Recorder({
                        fields: [
                            {
                                name: 'pricingTable',
                                selector: '#pricingTable',
                                percentage: .1,
                            },
                            {
                                name: 'mainContent',
                                selector: '#mainContent',
                                percentage: 2,
                            },
                        ],
                        reportInterval: 3,
                        callback: this.updateTimeSpent
                    })
                    this.rec.start()
                    if (prop.quote.liveQuoteVideoEnabled) {
                        this.openJitsi(prop.quote.id, prop.company.name, prop.customer.name)
                    }
                })
                GlobalHelper.captureFingerprint(location.href, res.attributes.accountId)
            })
        }
    }

    initLiveQuote(pusherKey, pusherCluster, quoteId) {
        const pusher = new Pusher(pusherKey, {
            cluster: pusherCluster
        });
        const channel = pusher.subscribe('live-quotes-' + quoteId)
        channel.bind('live-quote-refresh', this.refreshProposal)
        channel.bind('live-conversation-refresh', this.refreshProposal)
    }

    refreshProposal(data) {
        if (data.quoteId === this.state.proposal.quote.id) {
            AppContext.getApiClient().get('/proposals/' + this.props.match.params.hash).then(res => {
                this.setState({
                    proposal: res.attributes.variables
                })
            })
        }
    }

    openJitsi(roomName, companyName, userName) {
        const domain = 'meet.jit.si';
        const options = {
            roomName: roomName,
            width: 600,
            height: 400,
            interfaceConfigOverwrite: {
                APP_NAME: 'QuoteMachine',
                DEFAULT_REMOTE_DISPLAY_NAME: companyName,
                GENERATE_ROOMNAMES_ON_WELCOME_PAGE: false,
                DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                DISABLE_FOCUS_INDICATOR: true,
                DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
                DISABLE_PRESENCE_STATUS: true,
                DISABLE_TRANSCRIPTION_SUBTITLES: true,
                DISPLAY_WELCOME_PAGE_CONTENT: false,
                DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT: false,
                SHOW_CHROME_EXTENSION_BANNER: false,
                HIDE_INVITE_MORE_HEADER: true,
                TOOLBAR_BUTTONS: [
                    'microphone', 'camera', 'hangup',
                ],
            },
            parentNode: document.querySelector('#jitsi')
        };
        this.api = new JitsiMeetExternalAPI(domain, options)
        this.api.executeCommand('displayName', userName)
        this.api.addEventListener('videoConferenceLeft', (room) => {
            this.api.dispose()
        })
        this.api.addEventListener('videoConferenceJoined', (room) => {
            this.api.resizeLargeVideo(200, 140)
            $('#jitsi iframe').width(200)
            $('#jitsi iframe').height(140)
        })
        $('#jitsi').removeClass('d-none')
    }

    render() {
        if (!this.state.proposal) {
            return <LoadingSpinner marginTop="20px" />
        }
        if (this.state.proposal.global.isDeleted) {
            return <div className={'mt-5'}>
                <p className={'text-center h2 mb-3'}>
                    <Icon value={'ban'} />
                </p>
                <p className={'text-center h5'}>
                    <FormattedMessage
                        id="proposal.deleted_message"
                        defaultMessage="Sorry, this document has been deleted."
                    />
                </p>
            </div>
        }
        var showBranding = this.state.proposal.global.hasBranding
        let bannerStyle = null
        $('body').css('background-color', this.state.proposal.global.backgroundColor)
        if (this.state.proposal.global.backgroundImageUrl) {
            $('body').css({
                backgroundImage: `url(${this.state.proposal.global.backgroundImageUrl})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
            })
        } else if (this.state.proposal.global.bannerColor) {
            bannerStyle = {
                backgroundColor: this.state.proposal.global.bannerColor,
                width: '100%',
                height: '40%',
                position: 'absolute',
                zIndex: -1000,
                top: 0,
                left: 0,
            }
        }

        return <div>
            {bannerStyle ? <div style={bannerStyle}>
                <br />
            </div> : ''}
            <MetaTags>
                <title>{this.state.proposal.meta.title}</title>
                <meta name="title" content={this.state.proposal.meta.title} />
                <meta name="description" content={this.state.proposal.meta.description} />
                <meta property="og:title" content={this.state.proposal.meta.title} />
                <meta property="og:description" content={this.state.proposal.meta.description} />
                <meta property="og:type" content={'website'} />
                <meta property="og:image" content={this.state.proposal.meta.imageUrl} />
                <meta property="og:locale" content={this.state.proposal.global.language} />
                <meta property="twitter:title" content={this.state.proposal.meta.title} />
                <meta property="twitter:description" content={this.state.proposal.meta.description} />
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:image" content={this.state.proposal.meta.imageUrl} />
            </MetaTags>
            <div id={'mainContent'} className="container">
                <ProposalContent
                    variables={this.state.proposal}
                    showBranding={showBranding}
                    editable={false}
                    isDummy={this.state.isDummy}
                    mobile={this.state.mobile}
                    questionsChatDisabled={false}
                    project={this.state.project} />
            </div>
            <div className="jitsi-frame jitsi-frame-bottom-left d-flex justify-content-center align-items-center p-1 d-none" id={'jitsi'} />
        </div>
    }

}

export default Proposal





// WEBPACK FOOTER //
// ./src/proposal/proposal.component.jsx